import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalState {
  loading: boolean;
  error: string | null;
  theme: "light" | "dark";
  language: string;
  sidebarOpen: boolean;
}

const initialState: GlobalState = {
  loading: false,
  error: null,
  theme: "light",
  language: "en",
  sidebarOpen: false,
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setTheme: (state, action: PayloadAction<"light" | "dark">) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action: PayloadAction<string>) => {
      state.language = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.sidebarOpen = action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setTheme,
  setLanguage,
  toggleSidebar,
  setSidebarOpen,
} = globalSlice.actions;

export default globalSlice.reducer;